import React, { useState, useEffect, FC } from 'react'
import { Table, Modal } from 'antd'
import { Link, Redirect, useHistory } from 'react-router-dom'
import { Reseller, ResellerFormValues } from '../../types'
import { resellerService } from '../../services'
import { SearchBar, ResellerAccountForm, Page, useBreakpoints } from '../../components'
import styles from './index.module.less'
import { useAuth } from '../../providers/AuthProvider'

const { Column } = Table

const Resellers: FC = () => {
	const history = useHistory()
	const { user, userHasPermission } = useAuth()
	const [isVisible, setIsVisible] = useState<boolean>(false)
	const [filter, setFilter] = useState<string>('')
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [resellers, setResellers] = useState<Reseller[]>([])
	const breakpoints = useBreakpoints()
	const isMondagoAdmin = userHasPermission(['ServiceProvider.All.ReadWrite'])

	const createReseller = async (values: ResellerFormValues): Promise<void> => {
		const { data } = await resellerService.create(values)
		setIsVisible(false)
		history.push(`/reseller/${data.id}/children`)
	}

	useEffect(() => {
		const initServiceProviders = async (): Promise<void> => {
			setIsLoading(true)
			const resellers = await resellerService.getAll()
			setResellers(resellers.data)
			setIsLoading(false)
		}

		initServiceProviders()
	}, [])

	if (!isMondagoAdmin && user.resellers.length === 1) {
		const redirectPath = `/reseller/${user.resellers[0].id}/children`
		return <Redirect to={redirectPath} />
	}

	return (
		<Page title='Resellers'>
			<SearchBar
				className={styles.search}
				placeholder='Filter by name'
				search={setFilter}
				buttonProps={{
					onClick: (): void => setIsVisible(true),
					children: 'New reseller',
					icon: 'plus'
				}}
				debounceTime={50}
			/>
			<Table
				dataSource={resellers.filter(sp => (filter.length ? sp.name.toLowerCase().includes(filter.toLowerCase()) : true))}
				loading={isLoading}
				rowKey='id'
			>
				<Column
					title='Name'
					dataIndex='name'
					render={(name: string, record: Reseller): React.ReactNode => <Link to={`/reseller/${record.id}/children`}>{name}</Link>}
				/>
			</Table>
			<Modal
				// centered looks a lot better on mobile/shorter devices
				centered={breakpoints.md}
				visible={isVisible}
				onCancel={(): void => setIsVisible(false)}
				title={`Create new reseller`}
				footer={null}
			>
				<ResellerAccountForm submit={createReseller} />
			</Modal>
		</Page>
	)
}

export default Resellers
